import { CharacteristicsObject } from '../../characteristics/characteristics.model';
import { StringUtils } from 'src/app/services/utils/string.utils';
import { MessageObject } from '../../message/message-object.model';

export class TaskOperationObject {


    constructor(public comments: MessageObject, public characteristics: CharacteristicsObject) {

    }

    public static create(): TaskOperationObject {
        return new TaskOperationObject(MessageObject.create(), CharacteristicsObject.create());
    }
}
